import styled from 'styled-components';

const GuideRailFullContainer = styled.div<React.CSSProperties>``;

export default GuideRailFullContainer;
